import { INPUT_AUTOCOMPLETE_VALUE } from '../../../../constants/common'
import { ButtonArrow } from '../../../Button'
import { Input as InputComponent } from '../../../Input'
import { useSelectContext } from '../../../Select'
import Text from '../../../Text'
import { PHONE_SELECT_INPUT_NAME } from '../PhoneSelect.constants'

import * as styles from './PhoneSelectControlContent.module.css'

import DropdownIcon from '../../../../icons/dropdown.svg'

function PhoneSelectControlContent({
  Input = InputComponent,
  className = styles.PhoneSelectControlContent,
  inputProps,
  inputRef,
  inputValue,
  onChange,
}) {
  const { handleToggleOpen, isOpen, value } = useSelectContext()

  return (
    <div className={className}>
      <div className={styles.value}>
        <div className={styles.flagContainer}>
          <value.Icon className={styles.flag} />
          <ButtonArrow
            iconProps={{
              iconProps: { Icon: DropdownIcon },
            }}
            isOpen={isOpen}
            onClick={handleToggleOpen}
          />
        </div>
        <Text>{`+${value.phoneCode}`}</Text>
      </div>
      <Input
        {...inputProps}
        autoComplete={INPUT_AUTOCOMPLETE_VALUE.on}
        name={inputProps?.name || PHONE_SELECT_INPUT_NAME}
        ref={inputRef}
        value={inputValue}
        onChange={onChange}
      />
    </div>
  )
}

export default PhoneSelectControlContent
